export interface DeathCameraState {
  active: boolean
  zoom: number
  fadeAlpha: number
  showResults: boolean
  finished: boolean
}

function easeOutCubic(t: number): number {
  return 1 - (1 - t) ** 3
}

function easeInQuad(t: number): number {
  return t * t
}

export class DeathCamera {
  private active: boolean = false
  private elapsed: number = 0
  private readonly DURATION = 3.0
  private readonly RESULTS_POPUP_AT = 2.0
  private startZoom: number = 1.0
  private readonly END_ZOOM_FACTOR = 0.5

  /** Start death camera at current camera zoom level. */
  start(currentZoom: number): void {
    this.active = true
    this.elapsed = 0
    this.startZoom = currentZoom
  }

  /** Update per frame. Returns camera state. */
  update(dt: number): DeathCameraState {
    if (!this.active) {
      return {
        active: false,
        zoom: this.startZoom,
        fadeAlpha: 0,
        showResults: false,
        finished: false,
      }
    }

    this.elapsed += dt
    const t = Math.min(this.elapsed / this.DURATION, 1.0)

    // Zoom out from startZoom to startZoom * END_ZOOM_FACTOR with easeOutCubic
    const zoom = this.startZoom * (1 - (1 - this.END_ZOOM_FACTOR) * easeOutCubic(t))

    // Fade alpha: slow start, accelerating fade
    const fadeAlpha = easeInQuad(t)

    const showResults = this.elapsed >= this.RESULTS_POPUP_AT
    const finished = this.elapsed >= this.DURATION

    return {
      active: true,
      zoom,
      fadeAlpha,
      showResults,
      finished,
    }
  }

  /** Reset for next life. */
  reset(): void {
    this.active = false
    this.elapsed = 0
  }
}
